export default __webpack_public_path__ + "img/236f0e736f3a1250f2b8c90c3e3d0d16.svg";